import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'XfinityTheme',
  code: 'Comcast',
  colors: {
    headerBackground: '#000000',
    headerText: '#FFFFFF',
    headerBorder: '#000000',
    background: '#FFFFFF',
    footerBackground: '#000000',
    footerText: '#FFFFFF',
    footerBorder: '#000000',
    progressBar: '#3957E1',
  },
  logoSize: {
    width: '168px',
    height: '40px',
  },
  baseColors: {
    link: '#3957E1',
    cta: '#3957E1',
    hover: '#2F48BB',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const XfinityTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
